/**
 * Shared reservation + appointment CTAs for web and native unit details.
 * Logic uses these ids; UI maps them to i18n / labels. Do not switch on copy.
 */
export const ReservationCta = {
  RESERVE_UNIT: 'RESERVE_UNIT',
  VIEW_RESERVATION: 'VIEW_RESERVATION',
  BOOK_APPOINTMENT: 'BOOK_APPOINTMENT',
  VIEW_APPOINTMENT: 'VIEW_APPOINTMENT',
  CANCEL_RESERVATION: 'CANCEL_RESERVATION',
  RESEND_EMAIL: 'RESEND_EMAIL',
} as const;

export type ReservationCta =
  (typeof ReservationCta)[keyof typeof ReservationCta];

export type ReservationSlotCta =
  | typeof ReservationCta.RESERVE_UNIT
  | typeof ReservationCta.VIEW_RESERVATION;

export type AppointmentSlotCta =
  | typeof ReservationCta.BOOK_APPOINTMENT
  | typeof ReservationCta.VIEW_APPOINTMENT;

/** Unit-details footer: two slots. Cancel / Resend belong on the reservation view. */
export interface ReservationCtas {
  readonly reservation: ReservationSlotCta;
  readonly appointment: AppointmentSlotCta;
  readonly canCancelReservation: boolean;
  readonly canResendEmail: boolean;
}

export const RESERVATION_CTA_I18N_KEY = {
  [ReservationCta.RESERVE_UNIT]: 'propertyDetails.reserveUnitCta',
  [ReservationCta.VIEW_RESERVATION]: 'propertyDetails.viewReservationCta',
  [ReservationCta.BOOK_APPOINTMENT]: 'propertyDetails.bookAppointmentCta',
  [ReservationCta.VIEW_APPOINTMENT]: 'propertyDetails.viewAppointmentCta',
  [ReservationCta.CANCEL_RESERVATION]: 'reserveUnit.cancelReservation',
  [ReservationCta.RESEND_EMAIL]: 'reserveUnit.resendEmail',
} as const;
